module.exports = __webpack_public_path__ + "static/media/target.ff9233a3.svg";